import React, { useContext } from "react";
import { Button } from "../../ui/button";
import Image from "../../Tags/Image";
import { CheckCircle, Lock } from "lucide-react";
import SharedDataContext from "../../../SharedDataContext";

export default function FeaturePromotionView() {
  const userData = useContext(SharedDataContext);
  const { activeWorkspace } = userData || {};

  const handleContactSales = () => {
    const subject = encodeURIComponent(`Dialer Feature Request - ${activeWorkspace?.name || "Workspace"}`);
    const body = encodeURIComponent(
      `Hi,\n\nI'm interested in enabling the AI-Powered Sales Dialer feature for my workspace: ${activeWorkspace?.name || "Unknown"}.\n\nPlease contact me to discuss pricing and setup.\n\nThanks!`
    );
    window.open(`mailto:sales@primerole.com?subject=${subject}&body=${body}`, "_blank");
  };

  const features = [
    "Global reach: Dial to 100+ countries",
    "Smart call insights with AI analysis",
    "SMS, call logs and so much more...",
  ];

  return (
    <div className="flex flex-row items-center justify-center  px-4 min-h-[600px]">
      <div className="mb-8 mr-4">
        <Image
          src="/images/icons/untitledui/number-inventory/inventory-feature-promotion-view.svg"
          alt="AI-Powered Sales Dialer"
          className="mx-auto max-w-[240px] w-full"
        />
      </div>

      <div>
        <h2 className="text-lg font-semibold text-[#181D27] dark:text-white mb-2">AI-Powered Sales Dialer</h2>
        <p className="text-sm text-[#667085] dark:text-gray-300 mb-4 w-[550px]">
          Make effective sales calls with one-click dialing and AI-powered conversation insights
        </p>

        <div className="space-y-3 mb-8 text-left">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-[#7F56D9] flex-shrink-0" />
              <span className="text-sm text-[#535862] dark:text-gray-300">{feature}</span>
            </div>
          ))}
        </div>

        <Button onClick={handleContactSales}>
          <Lock className="h-4 w-4 mr-2 " />
          Contact Sales
        </Button>
      </div>
    </div>
  );
}
